import QuestionWithRubricForm from '../common/question-with-rubric-form/QuestionWithRubricForm'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { rubricPersistSelectors } from '../../../../../../../store/selectors/rubric.persist.selectors'
import { useFetchQuestionsQuery } from '../../../../../../../store/apis/question.api'
import { useParams } from 'react-router'
import { useBuildQuestionDefinitionsMutation } from '../../../../../../../store/apis/rubric.api'
import { rubricPersistActions } from '../../../../../../../store/slices/rubric.persist.slice'
import { Alert, Skeleton } from 'antd'

const CalibrationStep = () => {
    const { token } = useParams()
    const unmatchedRubricValues = useSelector(rubricPersistSelectors.unmatchedValuesPerQuestion(token))
    const unmatchedRubricValuesWithIds = unmatchedRubricValues.map((subArray, subArrayIndex) =>
        subArray.map((value, index) => ({
            content: value,
            id: `${subArrayIndex}-${index}`,
        })),
    )

    const dispatch = useDispatch()

    const { data: questions, isFetching, error } = useFetchQuestionsQuery({ token })
    const [buildQuestionDefinitions, buildQuestionDefinitionsResult] = useBuildQuestionDefinitionsMutation()

    const handleSubmit = async values => {
        const buildQuestionDefinitionsResponse = await buildQuestionDefinitions({
            filledQuestionSchema: values,
            indexOfFilledQuestion: 0,
            unmatchedValuesPerQuestion: unmatchedRubricValues,
        })

        if ('data' in buildQuestionDefinitionsResponse) {
            dispatch(
                rubricPersistActions.setRubricQuestions({
                    token,
                    rubricQuestions: buildQuestionDefinitionsResponse.data,
                }),
            )
            dispatch(rubricPersistActions.nextStep({ token }))
        }
    }

    if (isFetching) return <Skeleton active />
    if (error) return <Alert message={error} type='error' showIcon />

    return (
        <QuestionWithRubricForm
            unmatchedRubricValues={unmatchedRubricValuesWithIds}
            originalValues={questions[0]}
            onSubmit={handleSubmit}
            loading={buildQuestionDefinitionsResult.isLoading}
            error={buildQuestionDefinitionsResult.error}
            submitButtonText='Save & Next'
        />
    )
}

export default CalibrationStep
